import { GET_WAGON_TYPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_WAGON_TYPES_SUCCESS: {
      const wagonTypes = action.payload;

      if (!wagonTypes){
        return [...state];
      }

      return [
        ...state,
        ...wagonTypes
      ]
    }
    default:
      return state;
  }
}
